// frontend/src/features/orders/components/Pedidos/OrderPrintView.tsx
import { FullOrderDetails } from '../../services/ordersAPI';

const SIZES = [33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48];

const fmtCurrency = (v: any) => {
    const n = Number(v);
    return isNaN(n) ? 'R$ 0,00' : n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

const fmtDate = (d: string | null | undefined) => {
    if (!d) return '---';
    try { return new Date(d).toLocaleDateString('pt-BR'); } catch { return '---'; }
};

/**
 * Gera o HTML completo de impressão e abre em nova janela.
 */
export function openOrderPrint(details: FullOrderDetails, mode: 'internal' | 'client', isImbiseg: boolean = false) {
    const { pedido, items, resumo } = details;
    const p = pedido as any; // acesso genérico para campos opcionais
    const isInternal = mode === 'internal';

    const totalQtd = resumo?.TotalQuant || 0;
    const totalValor = resumo?.TotalValorProdutos || 0;
    const margemRS = Number(resumo?.MC_TOTAL || 0);
    const margemPct = totalValor > 0 ? (margemRS / totalValor) * 100 : 0;

    const endEntrega = p.ENTREGA_ENDERECO || p.CLIENTE_ENDERECO || '';
    const numEntrega = p.ENTREGA_NUMERO || p.CLIENTE_NUMERO || '';
    const bairroEntrega = p.ENTREGA_BAIRRO || p.CLIENTE_BAIRRO || '';
    const cidadeEntrega = p.ENTREGA_CIDADE || p.CLIENTE_CIDADE || '';
    const ufEntrega = p.ENTREGA_UF || p.CLIENTE_UF || '';
    const cepEntrega = p.ENTREGA_CEP || p.CLIENTE_CEP || '';

    const operacaoNome = (details.lookups?.operacoes?.find((o: any) => o.ID == p.OPERACAO_FISCAL) as any)?.DESCRIÇÃO || '---';

    // ── Gerar linhas de itens ──
    let itemsHtml = '';
    (items as any[]).forEach((item: any, idx: number) => {
        const qtd = SIZES.reduce((acc, s) => acc + (Number(item[s]) || 0), 0);
        const valTotal = (Number(item.PRECO) || 0) * qtd;

        // Linha principal do item
        itemsHtml += `
            <tr style="border-top:1px solid #ddd;">
                <td rowspan="2" style="width:45px; text-align:center; vertical-align:top; padding-top:4px;">
                    ${item.img_base64 ? `<img src="${item.img_base64}" style="max-width:40px; max-height:40px; display:block; margin: 0 auto;" />` : `<div style="width:40px; height:40px; background:#f0f0f0; margin: 0 auto;"></div>`}
                    ${item.COD_PCP ? `<div style="font-size:10px; margin-top:2px; color:#000;">C.A.: ${item.COD_PCP}</div>` : ''}
                </td>
                <td style="padding:4px; vertical-align:top; font-size:12px;">${item.ID}</td>
                <td style="padding:4px; vertical-align:top; font-size:10px; font-weight:bold; white-space:nowrap;">
                    ${item.REFERENCIA}${item.OPCIONAIS ? ' | ' + item.OPCIONAIS : ''}
                </td>
                <td style="padding:4px; vertical-align:top; font-size:10px;">
                    ${item.DESCRICAO}
                </td>
                <td style="padding:4px; text-align:center; vertical-align:top; font-size:12px;">${item.UNIDADE || 'Pares'}</td>
                ${isInternal ? `<td style="padding:4px; text-align:center; vertical-align:top; font-size:12px;">${item.TABELA || ''}</td>` : ''}
                <td style="padding:4px; text-align:center; font-weight:bold; vertical-align:top; font-size:12px;">${qtd}</td>
                <td style="padding:4px; text-align:right; vertical-align:top; font-size:12px;">${Number(item.PRECO || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                <td style="padding:4px; text-align:right; font-weight:bold; vertical-align:top; font-size:12px;">${fmtCurrency(valTotal)}</td>
            </tr>`;

        // Grade de tamanhos (novo formato visual: apenas tamanhos com valores)
        let sizeChipsHtml = '';
        SIZES.forEach(s => {
            const val = Number(item[s]) || 0;
            if (val > 0) {
                sizeChipsHtml += `
                    <div style="border:1px solid #000; display:flex; flex-direction:column; width:30px;">
                        <div style="background:#e5e7eb; text-align:center; font-size:11px; font-weight:bold; border-bottom:1px solid #000; padding:1px 0;">${s}</div>
                        <div style="text-align:center; font-size:12px; font-weight:bold; padding:2px 0; background:#fff;">${val}</div>
                    </div>
                `;
            }
        });

        const colSpan = isInternal ? 8 : 7;
        const backendQtd = Number(item.QUANTIDADE) || qtd || 1;
        const mcUnit = (Number(item.MC) || 0) / backendQtd;
        const mcPct = (Number(item.PRECO) || 0) > 0 ? (mcUnit / Number(item.PRECO) * 100) : 0;

        itemsHtml += `
            <tr>
                <td colspan="${colSpan}" style="padding:4px 4px 6px 4px; vertical-align:top;">
                    <div style="display:flex; gap:12px; align-items:flex-start;">
                        ${isInternal ? `
                        <div style="border:1px solid #000; display:flex; flex-direction:column; width:90px;">
                            <div style="background:#e5e7eb; text-align:center; font-size:10px; font-weight:bold; border-bottom:1px solid #000; padding:1px 0;">% - MC - R$</div>
                            <div style="text-align:center; font-size:11px; font-weight:bold; padding:2px 0; background:#fff;">${mcPct.toFixed(1)}% <span style="font-size:10px;font-weight:normal;color:#555;"> - ${fmtCurrency(Number(item.PRECO) || 0)}</span></div>
                        </div>
                        <div style="width:1px; background:#ddd; align-self:stretch;"></div>
                        ` : ''}
                        
                        <div style="display:flex; gap:6px; flex-wrap:wrap; flex:1;">
                            ${sizeChipsHtml}
                        </div>
                    </div>
                    ${isInternal ? `<div style="font-size:8px; color:#333; margin-top:4px; background:#f0f0f0; border:1px solid #ccc; display:inline-block; padding:2px 6px; font-weight:bold;">MARGEM MÍNIMA (permitida): ${Number(item.MC_MINIMA || 0).toFixed(2).replace('.', ',')}%</div>` : ''}
                </td>
            </tr>`;
    });

    // Totais do cliente (última linha)
    if (!isInternal) {
        itemsHtml += `
            <tr>
                <td colspan="8" style="padding:6px 4px;">
                    <div style="display:flex; gap:28px; justify-content:flex-end; border-top:2px solid #000; padding-top:4px; font-size:12px;">
                        <div><div style="font-weight:bold; border-bottom:1px solid #555; font-size:12px;">Qtde</div><div style="text-align:center; font-weight:bold;">${totalQtd}</div></div>
                        <div><div style="font-weight:bold; border-bottom:1px solid #555; font-size:12px;">Valor Total</div><div style="font-weight:bold;">${fmtCurrency(totalValor)}</div></div>
                    </div>
                </td>
            </tr>`;
    } else {
        // Totais Internos (última linha unificada)
        itemsHtml += `
            <tr>
                <td colspan="9" style="padding:6px 4px;">
                    <div style="display:flex; gap:40px; justify-content:space-between; border-top:2px solid #000; padding-top:4px; font-size:12px;">
                        <div><div style="font-weight:bold; border-bottom:1px solid #000; font-size:12px; padding-bottom:2px; margin-bottom:2px;">Prazo Médio</div><div>${p.PRAZO_MEDIO || '---'} - dias</div></div>
                        <div><div style="font-weight:bold; border-bottom:1px solid #000; font-size:12px; padding-bottom:2px; margin-bottom:2px;">Margem</div><div>${fmtCurrency(margemRS)}</div></div>
                        <div><div style="font-weight:bold; border-bottom:1px solid #000; font-size:12px; padding-bottom:2px; margin-bottom:2px;">Margem %</div><div>${margemPct.toFixed(2)} %</div></div>
                        <div style="margin-left:auto;"><div style="font-weight:bold; border-bottom:1px solid #000; font-size:12px; padding-bottom:2px; margin-bottom:2px; text-align:center;">Qtde</div><div style="text-align:center; font-weight:bold;">${totalQtd}</div></div>
                        <div><div style="font-weight:bold; border-bottom:1px solid #000; font-size:12px; padding-bottom:2px; margin-bottom:2px;">Valor Total</div><div style="font-weight:bold;">${fmtCurrency(totalValor)}</div></div>
                    </div>
                </td>
            </tr>`;
    }

    // Restrições (interno)
    const restricoesArray = (items as any[]).map((i: any) => i.RESTRICAO).filter(Boolean);
    const restricoes = Array.from(new Set(restricoesArray)).join(' | ');

    // ── Logo (absolute path from public) ──
    const logoUrl = window.location.origin + (isImbiseg ? '/logo-imbiseg.png' : '/Logo.webp');

    // ── HTML COMPLETO DO DOCUMENTO ──
    const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
    <meta charset="UTF-8">
    <title>Pedido #${p.ID} - ${isInternal ? 'Via Interna' : 'Via Cliente'}</title>
    <style>
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: #000; background: #fff; }
        .page {
            width: 210mm;
            min-height: 297mm;
            margin: 0 auto;
            padding: 10mm 12mm;
        }
        @media print {
            body { background: #fff; margin: 0; padding: 0; }
            .page { 
                width: 100%; 
                min-height: auto !important;
                padding: 0; 
                margin: 0; 
                box-shadow: none; 
            }
            @page { size: A4 portrait; margin: 6mm; }
            .no-print { display: none !important; }
        }
        @media screen {
            body { background: #555; padding: 20px 0; }
            .page { background: #fff; box-shadow: 0 4px 30px rgba(0,0,0,0.3); }
        }
    </style>
</head>
<body>

<!-- Botão de impressão (só na tela) -->
<div class="no-print" style="text-align:center; padding:12px;">
    <button onclick="window.print()" style="padding:10px 30px; background:#b91c1c; color:#fff; border:none; border-radius:6px; cursor:pointer; font-weight:700; font-size:15px; margin-right:8px;">
        🖨️ Imprimir
    </button>
    <button onclick="window.close()" style="padding:10px 24px; background:#fff; border:1px solid #ccc; border-radius:6px; cursor:pointer; font-weight:600; font-size:14px;">
        ✕ Fechar
    </button>
</div>

<div class="page">

    ${!isInternal ? '<div style="text-align:center; font-weight:bold; font-size:13px; border-bottom:1px solid #000; margin-bottom:8px; padding-bottom:3px;">via do cliente</div>' : ''}

    <!-- ═══ CABEÇALHO ═══ -->
    <div style="display:flex; justify-content:space-between; align-items:center; border-bottom:2px solid #000; padding-bottom:8px; margin-bottom:6px;">
        <div style="display:flex; align-items:center; gap:12px;">
            <img src="${logoUrl}" alt="Kadesh" style="height:58px; width:auto;" />
            <div style="font-size:12px; font-weight:bold; line-height:1.5;">
                KADESH CALÇADOS PROFISSIONAIS LTDA
                <span style="display:block; font-weight:normal; font-size:10px;">Rua Antônio Lourenço, 08 - Centro</span>
                <span style="display:block; font-weight:normal; font-size:10px;">Imbituva - PR - CEP 84430-000 Fone (42) 3436-8500</span>
            </div>
        </div>
        <table style="border-collapse:collapse; border:1px solid #000; min-width:185px; text-align:center;">
            <tr>
                <th style="border:1px solid #000; padding:3px 10px; background:#f0f0f0; font-size:10px; letter-spacing:0.5px;">PEDIDO</th>
                <th style="border:1px solid #000; padding:3px 10px; background:#f0f0f0; font-size:10px; letter-spacing:0.5px;">PRODUCAO</th>
            </tr>
            <tr>
                <td style="border:1px solid #000; padding:5px 10px; font-size:16px; font-weight:bold; letter-spacing:1px;">${p.ID}</td>
                <td style="border:1px solid #000; padding:5px 10px; font-size:16px; font-weight:bold; letter-spacing:1px;">${p.COD_TEOREMA || '---'}</td>
            </tr>
        </table>
    </div>

    <!-- ═══ EMISSÃO / VENDEDOR ═══ -->
    <div style="border:1px solid #aaa; padding:5px 8px; margin-bottom:5px; font-size:11px; line-height:1.7;">
        <div>
            <b>EMISSÃO:</b>&nbsp;&nbsp;${fmtDate(p.EMISSAO)}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <b>OPERAÇÃO:</b>&nbsp;${operacaoNome}
        </div>
        <div><b>VENDEDOR:</b>&nbsp;${p.VENDEDOR_NOME || p.VENDEDOR || '---'}</div>
        <div style="display:flex; justify-content:space-between;">
            <span><b>${p.SUPORTE || ''}</b></span>
            <span><b>COND.PGTO :</b>&nbsp;${p.COND_PAG_DESCRICAO || '---'}</span>
        </div>
    </div>

    <!-- ═══ CLIENTE ═══ -->
    <div style="border:1px solid #aaa; padding:5px 8px; margin-bottom:5px; font-size:11px; line-height:1.7;">
        <div style="display:flex; justify-content:space-between; align-items:baseline;">
            <div><b>CLIENTE:</b>&nbsp;<span style="font-size:11px; font-weight:bold;">${p.CLIENTE_NOME}</span></div>
            <div style="text-decoration:underline; font-weight:bold; font-size:12px;">${p.CLIENTE_SEGMENTO_NOME || ''}</div>
        </div>
        <div>
            <b>CNPJ :</b>&nbsp;${p.CLIENTE_CNPJ || ''}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <b>INC.EST</b>&nbsp;${p.CLIENTE_IE || ''}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <b>${p.CLIENTE_CIDADE || ''}</b>/${p.CLIENTE_UF || ''}
        </div>
        <div>
            <b>ENDERECO :</b>&nbsp;${p.CLIENTE_ENDERECO || ''}${p.CLIENTE_NUMERO ? ', <b>N°</b> ' + p.CLIENTE_NUMERO : ''}
        </div>
        <div style="display:flex; justify-content:space-between;">
            <span><b>COMPLEMENTO :</b>&nbsp;${p.CLIENTE_COMPLEMENTO || ''}</span>
            <span><b>FONE:</b>&nbsp;${p.CLIENTE_TELEFONE || ''}</span>
        </div>
        <div style="display:flex; justify-content:space-between;">
            <span><b>E-MAIL :</b>&nbsp;${p.CLIENTE_EMAIL || ''}</span>
            <span><b>BAIRRO :</b>&nbsp;${p.CLIENTE_BAIRRO || ''}</span>
            <span><b>CEP:</b>&nbsp;${p.CLIENTE_CEP || ''}</span>
        </div>
    </div>

    <!-- ═══ TABELA DE ITENS ═══ -->
    <table style="width:100%; border-collapse:collapse; font-size:12px; margin-top:2px;">
        <thead>
            <tr>
                <th style="border-top:2px solid #000; border-bottom:2px solid #000; padding:5px 4px; width:45px;"></th>
                <th style="border-top:2px solid #000; border-bottom:2px solid #000; padding:5px 4px; text-align:left; background:#f5f5f5; font-size:12px; width:45px;">ITEM</th>
                <th style="border-top:2px solid #000; border-bottom:2px solid #000; padding:5px 4px; text-align:left; background:#f5f5f5; font-size:12px; width:90px;">REF</th>
                <th style="border-top:2px solid #000; border-bottom:2px solid #000; padding:5px 4px; text-align:left; background:#f5f5f5; font-size:12px;">DESCRIÇÃO</th>
                <th style="border-top:2px solid #000; border-bottom:2px solid #000; padding:5px 4px; text-align:center; background:#f5f5f5; font-size:12px; width:40px;">UN</th>
                ${isInternal ? '<th style="border-top:2px solid #000; border-bottom:2px solid #000; padding:5px 4px; text-align:center; background:#f5f5f5; font-size:12px; width:40px;">TAB</th>' : ''}
                <th style="border-top:2px solid #000; border-bottom:2px solid #000; padding:5px 4px; text-align:center; background:#f5f5f5; font-size:12px; width:45px;">QTDE</th>
                <th style="border-top:2px solid #000; border-bottom:2px solid #000; padding:5px 4px; text-align:right; background:#f5f5f5; font-size:12px; width:65px;">PREÇO</th>
                <th style="border-top:2px solid #000; border-bottom:2px solid #000; padding:5px 4px; text-align:right; background:#f5f5f5; font-size:12px; width:75px;">$ TOTAL</th>
            </tr>
        </thead>
        <tbody>
            ${itemsHtml}
        </tbody>
    </table>



    <!-- ═══ FRETE ═══ -->
    <div style="border:1px solid #aaa; padding:6px 8px; margin-top:6px; font-size:10px;">
        <div style="display:flex; gap:40px; font-weight:bold; border-bottom:1px solid #ccc; padding-bottom:3px; margin-bottom:3px;">
            <span style="min-width:100px;">Frete</span>
            <span style="min-width:200px;">Transportador</span>
            <span>Redespacho</span>
        </div>
        <div style="display:flex; gap:40px; color:#333; margin-bottom:6px;">
            <span style="min-width:100px;">${p.FRETE_TIPO_DESCRICAO || p.TIPO_FRETE_NOME || 'CIF DESTINO'}</span>
            <span style="min-width:200px;">${p.TRANSPORTADORA || 'A DEFINIR'}</span>
            <span>${p.REDESPACHO_NOME || ''}</span>
        </div>
        <div style="font-weight:bold; border-bottom:1px solid #999; padding-bottom:2px; margin-bottom:4px;">Endereço de Entrega</div>
        <table style="width:100%; font-size:10px; border-collapse:collapse;">
            <tr>
                <th style="text-align:left; width:55%; padding:2px 4px;"></th>
                <th style="text-align:center; padding:2px 4px; font-weight:bold;">CEP</th>
                <th style="text-align:center; padding:2px 4px; font-weight:bold;">CIDADE</th>
                <th style="text-align:center; padding:2px 4px; font-weight:bold;">UF</th>
            </tr>
            <tr>
                <td style="padding:3px 4px;">
                    ${endEntrega}${numEntrega ? ', ' + numEntrega : ''}${bairroEntrega ? ' BAIRRO -- >' + bairroEntrega : ''}
                </td>
                <td style="text-align:center; padding:3px 4px;">${cepEntrega}</td>
                <td style="text-align:center; padding:3px 4px;">${cidadeEntrega}</td>
                <td style="text-align:center; padding:3px 4px;">${ufEntrega}</td>
            </tr>
        </table>
    </div>

    <!-- ═══ OBSERVAÇÕES ═══ -->
    <div style="margin-top:8px; font-size:10px;">
        <div style="font-weight:bold; margin-bottom:2px;">Observações</div>
        <div style="color:#1a56db; white-space:pre-wrap;">${p.OBS || ''}</div>
        <div style="margin-top:4px;">
            <div>R/C &nbsp;&nbsp;&nbsp; <u>ordem de compra</u></div>
            <div>R</div>
        </div>
        ${isInternal && restricoes ? `<div style="margin-top:4px; font-size:9px; text-decoration:underline; color:#c00;">${restricoes}</div>` : ''}
        ${isInternal && !restricoes ? '<div style="margin-top:4px; font-size:9px; text-decoration:underline; color:#c00;">RESTRIÇÕES</div>' : ''}
    </div>

</div>
</body>
</html>`;

    // ── Abrir nova janela e escrever o HTML ──
    const win = window.open('', '_blank', 'width=900,height=700');
    if (win) {
        win.document.write(html);
        win.document.close();
    }
}
